import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  StatusFormatter,
  columnsComplate,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";

import {
  addUploadFile,
  addVehicle,
  addVehicleUpload,
  fetchIdInbound,
} from "./inboundSlice";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { id } from "date-fns/locale";
import {
  prosesUpload,
  prosesUploadCancel,
} from "../miscellaneous/MiscellaneousSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const VehicleUploadView = ({
  isOpen,
  setShow,
  rowUpload,
  setRowUpload,
  rowUploadStatus,
  setRowUploadStatus,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClose = () => {
    setRowUpload(null);
    setShow(false);
  };

  const columns = [
    {
      text: "VIN",
      dataField: "VIN",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "VON",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Engine No",
      dataField: "Engine No",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Key No",
      dataField: "Key No",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Mileage",
      dataField: "Mileage",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Inspection Result",
      dataField: "Inspection Result",
      sort: true,

      headerAlign: "center",
    },
    {
      text: "Validation Result",
      dataField: "validate_file",
      sort: true,

      headerAlign: "center",
    },
  ];

  const handleProses = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUpload(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
        await setShow(false);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProsesCancel = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUploadCancel(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
        await setShow(false);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return (
    rowUpload && (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Upload Vehicle Information Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="d-flex mb-5">
            <div class="p-2 mr-auto font-weight-boldest ">
              Uploaded Vehicles Data from file "{rowUpload.file_name}"
            </div>
            <div class="p-2 font-weight-boldest">
              Status :{rowUpload.status}{" "}
            </div>
          </div>
          {rowUpload.status === "Uploaded" && (
            <Row className="ml-2 mb-5">
              <Button variant="primary" className="mr-5" onClick={handleProses}>
                Process Data
              </Button>
              <Button variant="danger" onClick={handleProsesCancel}>
                Cancel Process Data
              </Button>
            </Row>
          )}

          <>
            <div
              className=" "
              style={{
                maxHeight: "600px",
                overflowY: "scroll",
              }}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                keyField="no"
                data={rowUpload !== null ? rowUpload.data : []}
                columns={columnsComplate}
                hover
              />
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
};
